// eslint-disable-next-line no-shadow
export enum GfpPrintEnum {
  E = '1',
  D = '2'
}
